import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { InvoiceFrequencyType } from 'entities/Invoice';
import { RentOptionDocument, UnitTypeSetting } from '../model/types';

interface Params {
  page?: number;
  limit?: number;
  search?: string;
  warehouseId?: string | string[];
  unitTypeSetting?: UnitTypeSetting;
  invoiceFrequencyType?: InvoiceFrequencyType;
  minContractDuration?: number;
  unitSize?: number;
  isActive?: boolean;
  orderBy?: string;
}

export const getPaginatedRentOptionListingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaginatedRentOptionListing: build.query<Pagination<RentOptionDocument>, Params | void>({
      query: (args) => ({
        url: '/contracts/rent/rent-options/listing',
        params: args ? { ...args } : undefined,
      }),
      providesTags: ['Rent options'],
    }),
  }),
});

export const { useGetPaginatedRentOptionListingQuery } = getPaginatedRentOptionListingApi;
